import { mutatorAction } from "satcheljs";
import shiftDetailsStore from "../store";

export default mutatorAction('SET_IS_SAVING', function setIsSavingInStore(isSaving: boolean) {
    shiftDetailsStore.isSaving = isSaving;
});